import * as React from 'react'

import { useIndustryResources } from './IndustryResourcesProvider'
import { Button } from '../../../lib/ui/button'
import { useTranslation } from '../../../hooks/useTranslation'
import { SpinnerWhite } from '../../shared/Spinner'

export function PrimaryButton({ children, ...props }) {
  const { formDisabled } = useIndustryResources()
  const [fakeDisabled, setFakeDisabled] = React.useState(false)
  const fakeQuickSearch = () => {
    setFakeDisabled(true)
    setTimeout(() => {
      setFakeDisabled(false)
    }, 500)
  }

  const showSpinner = formDisabled || fakeDisabled

  return (
    <Button
      size="lg"
      className="w-full"
      disabled={formDisabled}
      type="submit"
      onClick={fakeQuickSearch}
      {...props}
    >
      {children}
      <SpinnerWhite show={showSpinner} className="pl-4" />
    </Button>
  )
}

export function ViewMoreButton() {
  const { handleViewMore, viewMoreButtonDisabled } = useIndustryResources()
  const { t } = useTranslation('ViewMoreButton')

  return (
    <Button
      className="w-full"
      onClick={handleViewMore}
      disabled={viewMoreButtonDisabled}
    >
      {t('view_more')}
      <SpinnerWhite show={viewMoreButtonDisabled} className="pl-4" />
    </Button>
  )
}
